class Reference {
  id: number;
  type: string;
  system: string;
  name?: string;
  dob?: string | Date;
  gender?: string;

  constructor(source?: {
    id: number;
    type: string;
    system: string;
    name?: string;
    dob?: string | Date;
    gender?: string;
  }) {
    if (!source) return;

    this.id = source.id;
    this.type = source.type;
    this.system = source.system;
    this.name = source.name;
    this.dob = source.dob;
    this.gender = source.gender;
  }
}

/**
 * Represents the context for the product that was purchased.
 */
class ProductReference {
  program?: Reference;
  registration?: Reference;
  participant?: Reference;
}

export {Reference, ProductReference};
